// extracted by mini-css-extract-plugin
export default {"thankYouDescription":"SuccessResend_thankYouDescription__Wz9RK","Form":"SuccessResend_Form__QRLTL","loginbg":"SuccessResend_loginbg__QGEqe"};